export default "__VITE_ASSET__CJPpXZz0__"